import MessageBox from './MessageBox';
import React from 'react';
import { SUPPORT_MESSAGE } from '../../shared/constants';

interface RequestVerificationEmailProps {
  message?: string;
}

const RequestVerificationEmailFail = (props: RequestVerificationEmailProps) => {
  return (
    <MessageBox
      header="Whoops!"
      message={
        props.message ||
        "We were unable to send a verification email to the email address you've supplied."
      }
      secondaryMessage={SUPPORT_MESSAGE}
    />
  );
};

export default RequestVerificationEmailFail;
